// extracted by mini-css-extract-plugin
module.exports = {"Blink":"AudioRecorder__Blink__3EJM4","blinker":"AudioRecorder__blinker__1b3x1"};